import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  reportTypeAddContainer: {
    display: 'flex',
  },
}));

export default useStyles;
